import { Injectable, WritableSignal, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public isExpanded: boolean = true;
  public redirectFromOrderReview: boolean = false;
  private desktopNavExpanded = new BehaviorSubject(this.isExpanded);
  private getStartedFromOrderReview = new BehaviorSubject(this.redirectFromOrderReview);
  public getDesktopNavToggle = this.desktopNavExpanded.asObservable();
  public getSetupWizard = this.getStartedFromOrderReview.asObservable();
  public wizardcomplete: boolean = false;

  constructor() {}

  public setDesktopNavToggle(expanded: boolean) {
    this.desktopNavExpanded.next(expanded);
  }

  public openSetupWizard(value: boolean) {
    this.getStartedFromOrderReview.next(value);
  }
}
